import styled from 'styled-components';

import { pageHeaderDesktopHeightWithSearchBar } from 'components/PageHeader/pageHeaderConstants';
import { cssBreakpoints } from 'theme/theme';

export const ListingViewSidebarHolder = styled.aside<{
  $withMaxHeight: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  position: sticky;
  top: ${pageHeaderDesktopHeightWithSearchBar}px;
  height: 100%;
  max-height: ${(props) =>
    props.$withMaxHeight
      ? `calc(100dvh - ${pageHeaderDesktopHeightWithSearchBar}px)`
      : undefined};
  min-height: 500px;
  overflow: auto;
  padding-top: 32px;
  word-break: break-word;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) and (max-width: ${cssBreakpoints.lgDown}) {
    width: 308px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    width: 418px;
  }
`;
